
class AttenuationUtils {

    constructor() {
        this.attenuations = [
            {
                attenuationClass: 1,
                thicknesses: [
                    { thickness: 10, attenuation1: 2.5, attenuation2: 8, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 15, attenuation1: 3.5, attenuation2: 10, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 20, attenuation1: 4.5, attenuation2: 12, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 25, attenuation1: 5.5, attenuation2: 14, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 30, attenuation1: 6.5, attenuation2: 15, attenuationFrequency1: 700, attenuationFrequency2: 3700 }
                ]
            },
            {
                attenuationClass: 2,
                thicknesses: [
                    { thickness: 10, attenuation1: 5.5, attenuation2: 14, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 15, attenuation1: 6.5, attenuation2: 16, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 20, attenuation1: 7.5, attenuation2: 18, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 25, attenuation1: 8.5, attenuation2: 18, attenuationFrequency1: 700, attenuationFrequency2: 3700 },
                    { thickness: 30, attenuation1: 9.5, attenuation2: 18, attenuationFrequency1: 700, attenuationFrequency2: 3700 }
                ]
            },
            {
                attenuationClass: 3,
                thicknesses: [
                    { thickness: 0.1, attenuation1: 15, attenuation2: 15, attenuationFrequency1: 700, attenuationFrequency2: 3700 }
                ]
            },
            {
                attenuationClass: 4,
                thicknesses: [
                    { thickness: 2, attenuation1: 0.5, attenuation2: 4, attenuationFrequency1: 1805, attenuationFrequency2: 3700 }
                ]
            }
        ];
    }

    getAttenuation(attenuation1, attenuation2, frequency1, frequency2) {
        for (const att of attenuationUtils.attenuations) {
            for (const thickness of att.thicknesses) {
                const matchAtt1 = thickness.attenuation1 === attenuation1;
                const matchFreq1 = thickness.attenuationFrequency1 === frequency1;
                const matchAtt2 = thickness.attenuation2 === attenuation2;
                const matchFreq2 = thickness.attenuationFrequency2 === frequency2;
                if (matchAtt1 && matchFreq1 && matchAtt2 && matchFreq2) {
                    return {
                        attenuationClass: att.attenuationClass,
                        thickness: thickness.thickness
                    };
                }
            }
        }
        return null;
    }

    getAttenuationClasses() {
        return [null, ...this.attenuations.map(item => item.attenuationClass)];
    }

    getThickness(attenuationClass, thickness) {
        if (attenuationClass === null || thickness === null) {
            return null;
        }
        const foundClass = this.attenuations.find(item => item.attenuationClass === attenuationClass);
        if (!foundClass) {
            return null;
        }
        return foundClass.thicknesses.find(item => item.thickness === thickness) || null;
    }

    getThicknesses(attenuationClassValue) {
        if (attenuationClassValue === null) {
            return [];
        }
        return [
            null,
            ...this.attenuations
                .filter(item => item.attenuationClass === attenuationClassValue)
                .flatMap(item => item.thicknesses)
                .map(item => item.thickness)
        ];
    }
}
const attenuationUtils = new AttenuationUtils();
export default attenuationUtils;